export const colors = {
  light: {
    background: "#F6F7FA",
    main: "#FBFCFF",
    secondary: "#F2F2F5",
    font: "#000",
    purple: "#79C384",
    fontSecondary: "#4F4F4F",
    purpleBg: "#F2F2F5",
    red: "#A13023",
    redSecondary: "#F2E2E2",
  },
  dark: {
    background: "#F6F7FA",
    main: "#FBFCFF",
    secondary: "#f6f7fa",
    font: "#467270",
    purple: "#467270",
    fontSecondary: "#000",
    purpleBg: "#f6f7fa",
    red: "#A13023",
    redSecondary: "#f6f7fa",
  },
};

export const fonts = {
  base: {
    fontFamily: "HelveticaNeueCyr",
  },
  small: {
    fontFamily: "HelveticaNeueCyr",
    fontSize: "12px",
    fontWeight: 550,
  },

  regular: {
    fontFamily: "HelveticaNeueCyr",
    fontSize: "14px",
  },

  normal: {
    fontFamily: "HelveticaNeueCyr",
    fontSize: "14px",
    fontWeight: 700,
  },
  h2: {
    fontFamily: "HelveticaNeueCyr",
    fontSize: "30px",
    fontWeight: 700,
  },
  h3: {
    fontFamily: "HelveticaNeueCyr",
    fontSize: "23px",
    fontWeight: 700,
  },
  h4: {
    fontFamily: "HelveticaNeueCyr",
    fontSize: "17px",
    fontWeight: 700,
  },
  p1: {
    fontFamily: "HelveticaNeueCyr",
    fontSize: "14px",
    fontWeight: 400,
  },
  p2: {
    fontFamily: "HelveticaNeueCyr",
    fontSize: "12px",
    fontWeight: 550,
  },
  p3: {
    fontFamily: "HelveticaNeueCyr",
    fontSize: "9px",
    fontWeight: 550,
  },
};

export type Mode = "light" | "dark";

declare module "@emotion/react" {
  export interface Theme {
    mode: "light" | "dark";
    colors: typeof colors;
    fonts: typeof fonts;
    toggleMode: () => void;
    switch: <T>(dark: T, light: T) => T;
  }
}

export const buildTheme = (mode: Mode, toggleMode?: () => void) => ({
  mode,
  toggleMode,
  switch: <T>(darkVal: T, lightVal: T) =>
    mode === "dark" ? darkVal : lightVal,
  colors,
  fonts,
});
